import { MenuItem, TextField, TextFieldProps } from '@mui/material';

import { t } from 'i18next';
import React from 'react';

import { useCoursesQuery } from 'api/hooks/useCoursesQuery';
import { translations } from 'locales/i18n';
import { sortCourses } from 'utils/courses';

interface Props extends Omit<TextFieldProps, 'variant'> {
  course: number | string | undefined;
  setCourse: React.Dispatch<React.SetStateAction<string>>;
  shouldUseIdAsValue?: boolean;
}

export const CourseSelect = ({ course, setCourse, shouldUseIdAsValue, ...props }: Props) => {
  const { data: courses } = useCoursesQuery();

  const sortedCourses = sortCourses(courses);

  return (
    <TextField
      {...props}
      select
      size="small"
      label={t(translations.common.course())}
      value={course}
      onChange={e => setCourse(e.target.value)}
      sx={{ minWidth: 200 }}
    >
      <MenuItem key={'---'} value={''}>
        ---
      </MenuItem>
      {sortedCourses.map(option => (
        <MenuItem
          key={`${option.name} (${option.shorthand})`}
          value={shouldUseIdAsValue ? option.id : option.shorthand}
        >
          {`${option.name} (${option.shorthand})`}
        </MenuItem>
      ))}
    </TextField>
  );
};
